import commonMessage from "../../constants/commonMessage";
import Regex from "../../utils/regexValidation";

const { passwordRegex } = Regex

const {
  OLD_PASSWORD_REQUIRED,
  NEW_PASSWORD_REQUIRED,
  CONFIRM_PASSWORD_REQUIRED,
  VALID_PASSWORD,
} = commonMessage;

export const userProfile = {
  //Change User Password Schema
  changeUserPasswordSchema: {
    oldPassword: {
      required: true,
      message: OLD_PASSWORD_REQUIRED,
    },
    newPassword: {
      required: true,
      message: NEW_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return value.match(passwordRegex);
      },
      invalidMessage: VALID_PASSWORD,
      extraMessage: true,
    },
    confirmPassword: {
      required: true,
      message: CONFIRM_PASSWORD_REQUIRED,
      validate: (value, inputData = {}) => {
        return value === inputData?.newPassword

      },
      invalidMessage: "Password does not match the new password.",
      extraMessage: true,
    },
  },
};
